import { Component, OnInit, Input } from '@angular/core';

export interface DescricaoCorFundoData {
  description: string;
  color: string;
  bgColor: string;
  centerTxt: boolean;
  hasMarginBottom: boolean;
}

@Component({
  selector: 'fcp-descricao-cor-fundo',
  templateUrl: './descricao-cor-fundo.component.html',
  styleUrls: ['./descricao-cor-fundo.component.scss']
})
export class DescricaoCorFundoComponent implements OnInit {

  @Input() public descricaoCorFundo: DescricaoCorFundoData;

  constructor() { }

  ngOnInit(): void {
  }

}
